import type { FileFormat, PluralFormat } from '../../../types';

const preparePluralFormatOptions = (
    fileFormat: FileFormat,
    pluralFormatSelect: readonly {
        value: PluralFormat;
        text: string;
    }[],
    pluralFormatWhitelist: Partial<Record<FileFormat, readonly PluralFormat[]>> | undefined,
) => {
    const whitelist = pluralFormatWhitelist?.[fileFormat] ?? [];

    return whitelist
        .map((pluralFormat) => {
            const format = pluralFormatSelect.find((item) => item.value === pluralFormat);

            if (!format) {
                return null;
            }

            return {
                value: format.value,
                label: format.text,
            };
        })
        .filter((item): item is { label: string; value: PluralFormat } => item !== null);
};

export default preparePluralFormatOptions;
